<h1>Saindo{{ text$ | async }}</h1>
